import React, { useState } from 'react';
import { Flex } from 'antd';

import { useList } from '../hooks/useList';
import { ProductsViewType } from '../service/products.interface';
import { ProductsCards } from '../components/ProductsCards';
import { ProductsActions } from '../components/ProductsActions';
import { ProductsTable } from '../components/ProductsTable';
import { ProductTabs } from '../components/ProductTabs';
import { PRODUCTS_VIEW } from '../utils/products';

export const ProductsContainer = () => {
    const {
        list,
        pagination,
        loading,
        updateFilters,
        filters,
        rowSelection,
        isMultipleActionsAvailable,
        isFiltersEqual,
        setSelectedRowKeys,
    } = useList();

    const [viewType, setViewType] = useState<ProductsViewType>(
        PRODUCTS_VIEW.table
    );

    const renderProducts = (viewType: ProductsViewType) => {
        switch (viewType) {
            case PRODUCTS_VIEW.cards:
                return (
                    <ProductsCards
                        list={list}
                        pagination={pagination}
                        isLoading={loading}
                    />
                );
            case PRODUCTS_VIEW.table:
                return (
                    <Flex gap={16} vertical>
                        <ProductsActions
                            isMultipleActionsAvailable={
                                isMultipleActionsAvailable
                            }
                            rowSelection={rowSelection}
                            updateFilters={updateFilters}
                            setSelectedRowKeys={setSelectedRowKeys}
                            filters={filters}
                            isFiltersEqual={isFiltersEqual}
                        />
                        <ProductsTable
                            rowSelection={rowSelection}
                            updateFilters={updateFilters}
                            filters={filters}
                            list={list}
                            pagination={pagination}
                            isLoading={loading}
                            isMultipleActionsAvailable={
                                isMultipleActionsAvailable
                            }
                        />
                    </Flex>
                );
        }
    };

    return (
        <>
            <ProductTabs
                filters={filters}
                setViewType={setViewType}
                viewType={viewType}
                updateFilters={updateFilters}
            />

            {renderProducts(viewType)}
        </>
    );
};
